import { render, staticRenderFns } from "./BookmarkTool.vue?vue&type=template&id=3f4ee9c4&scoped=true&"
import script from "./BookmarkTool.vue?vue&type=script&lang=ts&"
export * from "./BookmarkTool.vue?vue&type=script&lang=ts&"
import style0 from "./BookmarkTool.vue?vue&type=style&index=0&id=3f4ee9c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4ee9c4",
  null
  
)

export default component.exports